import React, { createContext, useContext } from 'react';

let createClient;
try {
  const supabaseJs = require('@supabase/supabase-js');
  createClient = supabaseJs.createClient || (supabaseJs.default && supabaseJs.default.createClient) || (typeof supabaseJs === 'function' ? supabaseJs : null);
} catch (e) {
  console.error('[configureSupabase] Failed to load @supabase/supabase-js:', e);
}

const DEFAULT_SUPABASE_URL = "https://ljaqxwjmglvixulmvabj.supabase.co";
const DEFAULT_SUPABASE_KEY = "sb_publishable_zApgbyOLBa3qRQd5NG43gA_7jLajE9i";

const SupabaseContext = createContext(null);

let supabase = null;

export const initSupabase = (config, AsyncStorage) => {
  const url = config?.url || DEFAULT_SUPABASE_URL;
  const anonKey = config?.anonKey || DEFAULT_SUPABASE_KEY;

  if (!createClient) {
    console.warn('[configureSupabase] @supabase/supabase-js createClient not available.');
    return null;
  }

  const options = {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: typeof window !== 'undefined',
    }
  };

  if (AsyncStorage) {
    options.auth.storage = AsyncStorage;
  }

  supabase = createClient(url, anonKey, options);
  return supabase;
};

export const getSupabase = () => {
  if (!supabase && createClient) {
    supabase = createClient(DEFAULT_SUPABASE_URL, DEFAULT_SUPABASE_KEY, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: typeof window !== 'undefined',
      }
    });
  }
  return supabase;
};

export const SupabaseProvider = ({ config, AsyncStorage, children }) => {
  if (!supabase || AsyncStorage) {
    initSupabase(config, AsyncStorage);
  }

  return (
    <SupabaseContext.Provider value={supabase || getSupabase()}>
      {children}
    </SupabaseContext.Provider>
  );
};

export const useSupabase = () => {
  return useContext(SupabaseContext) || getSupabase();
};

export const createIsolatedSupabaseClient = () => {
  if (!createClient) return null;
  const url = supabase?.supabaseUrl || DEFAULT_SUPABASE_URL;
  const anonKey = supabase?.supabaseKey || DEFAULT_SUPABASE_KEY;
  return createClient(url, anonKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
      detectSessionInUrl: false
    }
  });
};

export {
  supabase,
  SupabaseContext
};

